"use strict";

var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Router = void 0;
var enums_1 = require("./enums");
var meeting_1 = require("./meeting/");
var Router = /** @class */function () {
  function Router() {}
  Object.defineProperty(Router, "contentModeTypeUrlMap", {
    get: function () {
      var _a;
      return _a = {}, _a[enums_1.EContentModeType.all] = '', _a[enums_1.EContentModeType.my] = 'my', _a[enums_1.EContentModeType.favorites] = 'favorites', _a[enums_1.EContentModeType['last-viewed']] = 'last-viewed', _a[enums_1.EContentModeType['last-added']] = 'last-added', _a[enums_1.EContentModeType.popular] = 'popular', _a;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Router, "obsoleteContentModeTypeUrlMap", {
    /**
     * сюда вносить варианты URL типов контента, которые ранее использовались в продакшене
     * требуется для целостности роутинга и валидности данных
     */
    get: function () {
      return {};
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Router, "contentTypeUrlMap", {
    get: function () {
      var _a;
      return _a = {},
      // [ContentTypeEnum.lesson]: 'lessons',
      // [ContentTypeEnum.test]: 'tests',
      _a[enums_1.ContentTypeEnum.exercise] = 'exercises', _a[enums_1.ContentTypeEnum.theory] = 'theory', _a[enums_1.ContentTypeEnum.theory_exercise] = 'theory-exercises', _a[enums_1.ContentTypeEnum.audio] = 'podcasts', _a[enums_1.ContentTypeEnum.video] = 'video', _a[enums_1.ContentTypeEnum.image] = 'images', _a[enums_1.ContentTypeEnum.article] = 'articles',
      // [ContentTypeEnum.document]: 'documents',
      _a[enums_1.ContentTypeEnum.news] = 'news', _a[enums_1.ContentTypeEnum.vocabulary] = 'vocabulary-exercises', _a[enums_1.ContentTypeEnum.audio_lesson] = 'audio-exercises', _a[enums_1.ContentTypeEnum.video_lesson] = 'video-exercises', _a[enums_1.ContentTypeEnum.reading_lesson] = 'reading-exercises', _a[enums_1.ContentTypeEnum.microtext] = 'posts', _a[enums_1.ContentTypeEnum.reading] = 'reading', _a;
    },
    enumerable: false,
    configurable: true
  });
  Router.getNameByContentType = function (contentType) {
    return Router.contentTypeUrlMap[contentType];
  };
  Router.getContentTypeByName = function (name) {
    for (var contentType in Router.contentTypeUrlMap) {
      if (Router.contentTypeUrlMap[contentType] === name) {
        return +contentType;
      }
    }
    return null;
  };
  /**
   * @deprecated
   */
  Router.generateContentTypesUrlMap = function (path) {
    return Router.getContentTypesByPath(path);
  };
  /**
   * Для фрагмента URL возвращает список кодов типов контента
   */
  Router.getContentTypesByPath = function (path) {
    if (!path || path.length === 0) {
      return [];
    }
    var _types = [];
    path.split(Router.contentTypeDelimeter).forEach(function (s) {
      var type = enums_1.ContentTypeEnum[s];
      if (type) {
        _types.push(type);
      }
    });
    return _types;
  };
  /** Полная ссылка на страницу контента */
  Router.contentRoute = function (item) {
    if (item) {
      var subjectCode = item.subject.code || '-';
      var typeCode = item.type ? Router.getNameByContentType(item.type) : '';
      var title = (item.title || '').replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '').trim().replace(/\s+/g, '-');
      return ['/' + subjectCode, enums_1.EContentPanelRoute.lessons, typeCode,
      // item.author.slug,
      (title.length ? title + '-' : '') + item.slug];
    } else {
      return null;
    }
  };
  /** Короткая ссылка на страницу контента */
  Router.contentShortRoute = function (item) {
    if (item) {
      return ['/go/lessons', item.slug];
    } else {
      return null;
    }
  };
  /** Полная ссылка на страницу класса */
  Router.meetingRoute = function (meeting) {
    if (meeting) {
      var subjectCode = meeting.subject ? meeting.subject.code : null;
      var typeCode = Router.meetingTypeUrlMap[meeting.type] || Router.meetingTypeUrlMap[meeting_1.MeetingTypeEnum.group];
      var title = (meeting.title || '').replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '').trim().replace(/\s+/g, '-');
      return ['/' + enums_1.EContentPanelRoute.classes, subjectCode || '-', typeCode, (title.length ? title + '-' : '') + meeting.slug];
    } else {
      return null;
    }
  };
  /**
   * URL для проведения конференции
   *
   * @param meeting
   * @param host Имя хоста. По-умолчанию конференция проводится на текущем домене портала
   */
  Router.meetingSessionUrl = function (meeting, host) {
    if (host === void 0) {
      host = '';
    }
    if (meeting) {
      var subjectCode = meeting.subject ? meeting.subject.code : null;
      var typeCode = Router.meetingTypeUrlMap[meeting.type] || Router.meetingTypeUrlMap[meeting_1.MeetingTypeEnum.group];
      var route = ['/' + enums_1.EContentPanelRoute.classes, subjectCode || '-', typeCode];
      // tslint:disable-next-line:max-line-length
      // @example /study/-/group-lessons/?s=574ffef1-c586-4941-8e3c-d45cdb44b5e4
      // @example /study/english-language/individual-lessons/?s=574ffef1-c586-4941-8e3c-d45cdb44b5e4
      // @example https://meet.onclass.tech/study/english-language/individual-lessons/?s=574ffef1-c586-4941-8e3c-d45cdb44b5e4
      return host + route.join('/') + '?s=' + meeting.session_id;
    } else {
      return null;
    }
  };
  /** Короткая ссылка на страницу контента */
  Router.meetingShortRoute = function (item) {
    if (item) {
      return ['/go/classes', item.slug];
    } else {
      return null;
    }
  };
  /** Пригласительная ссылка в класс */
  Router.meetingJoinRoute = function (item) {
    if (item) {
      return Router.meetingJoinRouteBySlug(item.slug);
    } else {
      return null;
    }
  };
  /** Пригласительная ссылка в класс */
  Router.meetingJoinRouteBySlug = function (meetingSlug) {
    return ['/' + enums_1.EContentPanelRoute.classes, 'join', meetingSlug];
  };
  /** Полная ссылка на страницу коллекции */
  Router.collectionRouteUniversal = function (item) {
    var _a;
    if (item && item.slug) {
      var subjectCode = ((_a = item.subject) === null || _a === void 0 ? void 0 : _a.code) || '-';
      var typeCode = 'collection'; // item.category?.code || '-';
      var title = (item.title || '').replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '').trim().replace(/\s+/g, '-');
      return ['/' + subjectCode, enums_1.EContentPanelRoute.collections, typeCode, (title.length ? title + '-' : '') + item.slug].join('/');
    }
    return null;
  };
  /** Полная ссылка на страницу школы */
  Router.schoolRoute = function (school) {
    return ['/', 'schools', (school === null || school === void 0 ? void 0 : school.urlPart) || (school === null || school === void 0 ? void 0 : school.slug)];
  };
  /** Полная ссылка на страницу классной комнаты */
  Router.classroomRoute = function (classroom) {
    var title = (classroom.title || '').replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '').trim().replace(/\s+/g, '-');
    return ['/classrooms', (title.length ? title + '-' : '') + classroom.slug];
  };
  /** Полная ссылка на страницу индивидуального занятия */
  Router.userServiceRouteUniversal = function (item) {
    var _a, _b;
    if (item) {
      var subjectCode = ((_a = item.subject) === null || _a === void 0 ? void 0 : _a.code) || '-';
      var typeCode = ((_b = item.category) === null || _b === void 0 ? void 0 : _b.code) || '-';
      var title = (item.title || '').replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '').trim().replace(/\s+/g, '-');
      return ['/' + subjectCode, enums_1.EContentPanelRoute.classes, typeCode, (title.length ? title + '-' : '') + item.slug].join('/');
    } else {
      return null;
    }
  };
  /**
   * сюда вносить варианты URL типов контента, которые ранее использовались в продакшене
   * требуется для целостности роутинга и валидности данных
   */
  Router.obsoleteContentTypeUrlMap = {};
  Router.meetingTypeUrlMap = (_a = {}, _a[meeting_1.MeetingTypeEnum.single] = 'individual-lessons', _a[meeting_1.MeetingTypeEnum.group] = 'group-lessons', _a[meeting_1.MeetingTypeEnum.webinar] = 'webinars', _a[meeting_1.MeetingTypeEnum.stream] = 'streams', _a);
  Router.obsoleteMeetingTypeUrlMap = {};
  Router.contentTypeDelimeter = ',';
  return Router;
}();
exports.Router = Router;
